import { defineStore } from 'pinia'

import { useOAuthStore } from 'src/stores/oauth.js'
import { useUsersStore } from 'src/stores/users.js'

import { suggestions } from 'src/api/public.js'

// the load under way, if any
let pending = null

// Accounts the server suggests, for the who-to-follow page and panel.
export const useWhoToFollowStore = defineStore('whoToFollow', {
  state: () => ({
    ids: [],
    loaded: false,
  }),
  getters: {
    users: (state) =>
      state.ids.map((id) => useUsersStore().findUser(id)).filter(Boolean),
  },
  actions: {
    // one request: the suggestions come as whole accounts; a load while
    // one runs (page and panel at once) shares it
    load() {
      const credentials = useOAuthStore().token
      if (!credentials) return Promise.resolve()
      pending ??= suggestions({ credentials })
        .then((result) => {
          this.ids = useUsersStore()
            .addNewUsers(result)
            .map((user) => user.id)
        })
        .catch((error) => {
          console.error(error)
          this.ids = []
        })
        .finally(() => {
          this.loaded = true
          pending = null
        })
      return pending
    },
  },
})
